import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const AspectRatio = ({ className, width, height, children }) => {
  const paddingBottom = { paddingBottom: `${(height / width) * 100}%` };

  return (
    <div style={paddingBottom} className={ClassNames('AspectRatio', className)}>
      {children}
      <style jsx>
        {`
          .AspectRatio {
            position: relative;
          }
          .AspectRatio:before {
            display: block;
            content: '';
            width: 100%;
          }
        `}
      </style>

      <style jsx global>
        {`
          .AspectRatio > * {
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            display: block;
            position: absolute;
          }
        `}
      </style>
    </div>
  );
};

AspectRatio.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

AspectRatio.defaultProps = {
  className: null,
};

export default AspectRatio;
